import { render, staticRenderFns } from "./lib.component.vue?vue&type=template&id=489df850&scoped=true"
import script from "./lib.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./lib.component.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./lib.component.vue?vue&type=style&index=0&id=489df850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489df850",
  null
  
)

export default component.exports